package com.vizio.redwolf.auth.model

data class EmailVerifiedRequestInfo(val accessToken: String)